import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button, Group, Modal, Text } from '@mantine/core';

type Props = {
  title: string;
  description?: string;
  onSuccess: () => void;
};

export const ConfirmModal = NiceModal.create(({ onSuccess, title, description }: Props) => {
  const modal = useModal();

  return (
    <Modal
      centered
      overlayProps={{ opacity: 0.4, blur: 1.5 }}
      opened={modal.visible}
      onClose={() => modal.remove()}
      title={title}
    >
      {description && (
        <Text size="sm" c="dimmed">
          {description}
        </Text>
      )}
      <Group pt={20} justify="right">
        <Button
          onClick={() => {
            onSuccess();
            modal.remove();
          }}
        >
          Yes
        </Button>
        <Button onClick={modal.remove} variant="outline" color="red">
          No
        </Button>
      </Group>
    </Modal>
  );
});
